<script>


</script>

<template>
  <svg fill="none" height="17" viewBox="0 0 66 17" width="66" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5_233)">
      <path d="M8.56593 4.36084H4.49359V16.6304H8.56593V4.36084Z" fill="#220F48"/>
      <path d="M4.49362 0H0V4.36087H4.49362V0Z" fill="#EB174F"/>
      <path
          d="M17.9043 4.06543C19.1681 4.06543 20.1511 4.50891 20.9234 5.39586C21.6957 6.28282 22.117 7.61326 22.117 9.31326V16.6306H18.3255V9.83065C18.3255 9.16543 18.1851 8.72195 17.834 8.35239C17.5532 8.05673 17.1319 7.835 16.5702 7.835C16.0085 7.835 15.517 7.98282 15.166 8.4263C14.8851 8.86978 14.7447 9.46108 14.7447 10.1263V16.6306H10.9532V4.43499H14.7447V5.69152C15.4468 4.58282 16.4298 4.06543 17.9043 4.06543Z"
          fill="#220F48"/>
      <path
          d="M31.2447 8.27833H28.8575V11.8262C28.8575 12.3435 29.0681 12.7131 29.4192 12.8609C29.7702 13.0088 30.4021 13.0088 31.2447 13.0088V16.7044C28.9979 17.0001 27.383 16.7783 26.4702 16.0392C25.5575 15.3001 25.066 13.9696 25.066 11.974V8.27833H23.3809V4.43485H25.066V2.21746L28.8575 0.960938V4.43485H31.2447V8.27833Z"
          fill="#220F48"/>
      <path
          d="M36.1596 12.048C36.5106 13.0089 37.4234 13.5263 38.6872 13.5263C39.5298 13.5263 40.2319 13.2306 40.7936 12.6393L43.5319 14.7089C42.4085 16.2611 40.7234 17.0002 38.617 17.0002C36.6511 17.0002 35.1064 16.4089 33.983 15.1524C32.8596 13.9698 32.2277 12.4176 32.2277 10.5698C32.2277 8.72195 32.7894 7.16978 33.9128 5.91326C35.0362 4.65673 36.5106 4.06543 38.266 4.06543C39.9511 4.06543 41.3553 4.65673 42.4787 5.91326C43.6021 7.16978 44.1638 8.64804 44.1638 10.4959C44.1638 11.0133 44.0936 11.5306 44.0234 11.9741L36.1596 12.048ZM36.0894 9.23934H40.4426C40.1617 8.13065 39.4596 7.53934 38.266 7.53934C37.1426 7.46543 36.4404 8.05673 36.0894 9.23934Z"
          fill="#220F48"/>
      <path
          d="M49.5702 6.6522C49.7809 5.83916 50.2022 5.24786 50.8341 4.80438C51.466 4.3609 52.1681 4.13916 53.0107 4.13916V8.64786C52.1681 8.50003 51.3256 8.64786 50.6234 9.16525C49.9213 9.68264 49.5702 10.4957 49.5702 11.5305V16.6305H45.7787V4.43481H49.5702V6.6522Z"
          fill="#220F48"/>
      <path
          d="M62.2085 4.43499H66V16.7046H62.2085V15.522C61.4362 16.4828 60.3128 17.0002 58.9787 17.0002C57.4341 17.0002 56.1702 16.4089 55.1873 15.1524C54.1341 13.8959 53.6426 12.3437 53.6426 10.5698C53.6426 8.79586 54.1341 7.16978 55.1873 5.98717C56.1702 4.73065 57.4341 4.06543 58.9787 4.06543C60.383 4.06543 61.4362 4.58282 62.2085 5.54369V4.43499ZM58.066 12.4915C58.4873 13.0089 59.049 13.2306 59.8213 13.2306C60.5936 13.2306 61.0851 13.0089 61.5766 12.4915C61.9979 11.9741 62.2085 11.3828 62.2085 10.5698C62.2085 9.75673 61.9979 9.09152 61.5766 8.64804C61.1553 8.13065 60.5936 7.90891 59.8213 7.90891C59.049 7.90891 58.5575 8.13065 58.066 8.64804C57.6447 9.16543 57.4341 9.75673 57.4341 10.5698C57.4341 11.3828 57.6447 11.9741 58.066 12.4915Z"
          fill="#220F48"/>
    </g>
    <defs>
      <clipPath id="clip0_5_233">
        <rect fill="white" height="17" width="66"/>
      </clipPath>
    </defs>
  </svg>


</template>

<style lang="scss" scoped>

</style>